'use strict';

angular.module('TurneroApp').service('usuariosService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Usuario/:id', { id: '@Id_Usuario' }, {
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            params: {
                id_Usuario: '@id_Usuario',
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
        },
        getInfo: {
            method: 'GET',
            params: {
                id_usuario: 'id_usuario',
                Id_Centro_Usuario: 'Id_Centro_Usuario'
            },
            url: portal.getUrlServer() + 'api/Usuario/getInfo/',

        },
        getCiDiInfo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Usuario/getCiDiInfo/:CUIL/',
        },
        getCiDiInfoByCookie: {
            method: 'GET',
            param: {
                cookie: 'cookie'
            },
            url: portal.getUrlServer() + 'api/Usuario/getCiDiInfoByCookie/:cookie/',
        },
        getPaises: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Usuario/getPaises/'
        },
        Post_Usuario_Sesion_Atencion: {
            method: 'POST',
            params:{
                id_centro_atencion: '@id_centro_atencion',
                id_puesto: '@id_puesto'
            },
            url: portal.getUrlServer() + 'api/Usuario/Post_Usuario_Sesion_Atencion/'
        },
        save: {
            method: 'POST',
        },
        Post_Persona: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Usuario/Post_Persona/',
        },
        Post_Salir_Atencion: {
            method: 'POST',
            params: {
                id_usuario_sesion: '@id_usuario_sesion',
                id_centro_atencion: '@id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/Usuario/Post_Salir_Atencion/',
        },
        Post_Movimiento_Usuario_Sesion: {
            method: 'POST',
            params: {
                id_usuario_sesion: '@id_usuario_sesion',
                id_agenda: '@id_agenda',
                id_centro_usuario: '@id_centro_usuario',
                id_centro_atencion: '@id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/Usuario/Post_Movimiento_Usuario_Sesion/',
        },
        Post_Cerrar_Sesion: {
            method: 'POST',
            url: portal.getUrlServer() + 'api/Usuario/Post_Cerrar_Sesion/',
        },
        Post_Cerrar_Sesion_Centros:{
        	method: 'POST',
        	params:{
				id_centro_atencion: '@id_centro_atencion'
        	},
        	url: portal.getUrlServer() + 'api/Usuario/Post_Cerrar_Sesion_Centros/',
        },
        'delete': {
            param:{
                id : 'id_'
            },
            method: 'DELETE',
        },
        update: {
            method: 'PUT',
            params: {
                id: '@Id_Centro_Usuario'
            },
        },
        Traer_Usuarios_Activos_Combo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Usuario/Traer_Usuarios_Activos_Combo/',
        },
        Post_Claim_Notificar_Nuevos_Turnos: {
            method: 'POST',
            params: {
                notificarNuevosTurnos: '@notificarNuevosTurnos'
            },
            url: portal.getUrlServer() + 'api/Usuario/Post_Claim_Notificar_Nuevos_Turnos/',
        },
        Traer_Usuarios_Control_Permisos: {
            method: 'GET',
            params: {               
                Id_Centro_Atencion: 'Id_Centro_Atencion',
                Id_Agenda: 'Id_Agenda'
            },
            url: portal.getUrlServer() + 'api/Usuario/Traer_Usuarios_Control_Permisos/',
        },
        Post_Claim_Notificar_Tiempo_Espera_Excedido: {
            method: 'POST',
            params: {
                notificarTiempoEsperaExcedido: '@notificarTiempoEsperaExcedido'
            },
            url: portal.getUrlServer() + 'api/Usuario/Post_Claim_Notificar_Tiempo_Espera_Excedido/',
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/usuarios/usuariosService.js